import React from "react";
import ReactDOM from "react-dom/client";
import Container from "./Container";

let timer = null;
function checkAxiomAPIs() {
  if (typeof AxiomAPIs != "undefined") {
    clearInterval(timer);
    AxiomAPIs.registerApp("Home", renderReact, false);
  }
}

function renderReact(element, props) {
  const appRoot = ReactDOM.createRoot(element);
  appRoot.render(
    <Container
      appName={props.appName}
      appID={props.appID}
      backgroundColor={props.backgroundColor}
      client={props.client}
    />
  );
}

timer = setInterval(checkAxiomAPIs, 100);

document.addEventListener("DOMContentLoaded", function () {
  const timer = setInterval(function () {
    const appName = "Home";
    if (AxiomAPIs.registeredApps[appName]) {
      clearInterval(timer);
      const appMountPoint = document.getElementById("app");
      AxiomAPIs.bindApp(appName, 0, appMountPoint, { authorized: true });
    }
  }, 100);
});